import { Store, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import { createLogger } from "redux-logger";
import { History } from "history";
import { ApplicationState, createRootReducer } from "@reducers/index";
import rootSaga from "@sagas/index";

const logger = createLogger();

export default function configureStore(
  history: History,
  initialState: ApplicationState
): Store<ApplicationState> {
  const composeEnhancers = composeWithDevTools({});
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    createRootReducer(history),
    initialState,
    composeEnhancers(
      applyMiddleware(
        // routerMiddleware(history),
        sagaMiddleware,
        logger
      )
    )
  );
  sagaMiddleware.run(rootSaga);
  return store;
}
